import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FiltersIcon from "../../images/icons/FiltersIcon.svg";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import { FiltersMenuStyle, FiltersMenuXSStyle } from "../../Theme";
import { MHxFiltersOptions } from "../Content";

type IconType = () => JSX.Element;
export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}
export interface DialogContentProps {
  title?: string;
  children?: any;
  windowsize?: any;
  icon?: IconType;
  show?: any;
  close?: any;
  mxvalue?: any;
  handleChange?: any;
  setMXValue?: any;
  showMenu?: any;
  handleShowMenuClick?: any;
  disabled: any;
}

export const MedicationHxFilters: React.FC<DialogContentProps> = ({
  mxvalue,
  handleChange,
  disabled,
}) => {
  const [anchorElMHx, setAnchorElMHx] = React.useState<null | HTMLElement>(
    null
  );
  const open = Boolean(anchorElMHx);

  const handleMHxClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMHx(event.currentTarget);
  };
  const handleMHxClose = () => {
    setAnchorElMHx(null);
  };
  return (
    <>
      <FiltersMenuStyle>
        <IconButton onClick={handleMHxClick}>
          <img src={FiltersIcon} alt="Filters" loading="lazy" />
        </IconButton>
        <Typography variant="body2" component={"div"}>
          Filters
        </Typography>
      </FiltersMenuStyle>
      <FiltersMenuXSStyle
        anchorEl={anchorElMHx}
        open={open}
        onClose={handleMHxClose}
        onClick={handleMHxClose}
        PaperProps={{
          elevation: 0,
          className: "menu",
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <RadioGroup value={mxvalue} onChange={handleChange}>
          {MHxFiltersOptions.map(({ text, value }, index) => {
            return (
              <FormControlLabel
                key={index}
                className={mxvalue === value ? "active" : ""}
                value={value}
                control={<Radio />}
                label={text}
                disabled={disabled}
              />
            );
          })}
        </RadioGroup>{" "}
      </FiltersMenuXSStyle>
    </>
  );
};
